import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import {
  Container,
  Typography,
  TextField,
  Button,
  Alert,
  Paper,
  Stack,
} from '@mui/material';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();

  const resetPassword = async () => {
    setError('');
    setSuccess('');

    if (!email) {
      setError('Please enter your email address.');
      return;
    }

    setIsSubmitting(true);

    try {
      const auth = getAuth();
      await sendPasswordResetEmail(auth, email);
      setSuccess('A reset link has been sent to your email. Redirecting to login...');

      setTimeout(() => {
        navigate('/login');
      }, 4000);
    } catch (e) {
      console.log('Error:', e.code, e.message);
      switch (e.code) {
        case 'auth/missing-email':
          setError('Please enter an email address.');
          break;
        case 'auth/invalid-email':
        case 'auth/user-not-found':
          setError('That email does not exist in our system.');
          break;
        default:
          setError('Something went wrong. Please try again later.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 10 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom>
          Reset Password
        </Typography>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

        <Stack spacing={2}>
          <TextField
            type="email"
            label="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={success !== ''}
            fullWidth
            required
          />

          <Button
            onClick={resetPassword}
            disabled={isSubmitting || success !== ''}
            variant="contained"
            fullWidth
          >
            {isSubmitting ? 'Sending...' : 'Send Reset Link'}
          </Button>

          <Button
            component={Link}
            to="/login"
            variant="text"
          >
            Back to Login
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
};

export default ForgotPasswordPage;
